import React from "react"
import styled from "styled-components"
import { isMobile } from "react-device-detect"

import { family } from "../elements/font"

const CardContainer = styled.div`
  width: 100%;
  position: relative;
  border: 2px solid rgba(216, 210, 210, 0.7);
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 35px 20px 25px 20px;
  margin-bottom: ${props => (props.noMargin ? "0" : "10px")};
  @media only screen and (max-width: 800px) {
    padding: ${props =>
      props.big ? "20px 16px 35px 20px" : "20px 16px 20px 20px"};
    border-radius: unset;
  }
`

const Number = styled.p`
  margin: 0;
  width: 70px;
  height: 70px;
  font-family: ${family.Archivo};
  font-size: 1.8rem;
  letter-spacing: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff9db;
  border: 1px solid rgba(0, 0, 0, 0.6);
  box-sizing: border-box;
  border-radius: 13px;
  color: black;
  -webkit-text-fill-color: #f5faff;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
  @media only screen and (max-width: 600px) {
    width: 60px;
    height: 60px;
    font-size: 25px;
  }
`

const Content = styled.div`
  width: 87%;
  text-align: left;
  margin-left: 12px;
  @media only screen and (max-width: 800px) {
    width: 75%;
  }

  @media screen and (max-width: 900px) and (max-height: 430px) {
    margin-left: 20px;
  }
`

const CardTitle = styled.div`
  font-size: 0.8rem;
  font-family: ${family.Alata};
  line-height: 1rem;
  font-weight: 500;
  @media only screen and (max-width: 800px) {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 10px;
  }
`

const CardText = styled.div`
  font-size: 0.8rem;
  font-family: ${family.NATS};
  line-height: 1rem;
  margin-top: 3px;
  font-weight: 100;
  @media only screen and (max-width: 800px) {
    font-size: 10px;
    line-height: 12px;
  }
`

const CardCount = styled.p`
  position: absolute;
  bottom: 2px;
  left: 10px;
  color: #f5faff;
  font-family: ${family.Archivo};
  font-size: 11px;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  margin: 0;
  letter-spacing: 2px;
`

const Card = ({ index, title, text }) => (
  <CardContainer noMargin={index === 6} big={index === 1 || index === 2}>
    <Number>{"#" + index}</Number>
    <Content>
      <CardTitle>
        {title.split("\n").map((item, i) => (
          <span key={i}>
            {item}
            <br />
          </span>
        ))}
      </CardTitle>
      <CardText>{text}</CardText>
    </Content>
    {isMobile && <CardCount>{index + "/6"}</CardCount>}
  </CardContainer>
)

export default Card
